module.exports = __webpack_public_path__ + "img/keder_zinkgelb_ral1018.4c78119b.jpg";